import { RouterStore } from "mobx-react-router";

export function getQueryParam($router: RouterStore, key: string) {
    return new URLSearchParams($router.location.search).get(key);
}

export function hasProtocol(url: string) {
    return url.match(/^https?:\/\//);
}
